import restClient from 'Shared/hooks/restClient'
import Loading from 'Shared/components/Loading'
import Context from 'CampaignVolunteer/Context'

export default function OrganisationChooser() {
  const { state, dispatch, actions } = useContext(Context)
  const { campaign, organisationKinds, externalType, user } = state
  const { chooseOrg } = actions

  useEffect(() => {
    restClient.get(`/api/organisations/schema`)
      .then((response) => dispatch({ organisationKinds: response.data }))
  }, [])

  return <div>
    {externalType ? (<div className="margin-top margin-bottom flex-center gap-5 cursor-pointer" onClick={() => dispatch({ externalType: null })}>
      <h2 className="no-margin-top no-margin-bottom">{ i18n.t('user.campaigns.choose_organisation', { organisation_kind: externalType }) }</h2>
      <SvgIconsEdit color={'currentColor'} />
    </div>) : (<div className="margin-top margin-bottom flex-center gap-5">
      <h2 className="no-margin-top no-margin-bottom">{ i18n.t('user.campaigns.choose_organisation_kind') }</h2>
    </div>)}
    { !externalType && <div className='organisation-kinds margin-bottom'>
      { organisationKinds?.map((organisationKind) => {
        return <div className='organisation-kind' key={organisationKind.externalType}>
          <a className='card large selectable' onClick={() => dispatch({ externalType: organisationKind.externalType })}>
            <div className='icon large purple'><SvgIconsSmsBlast /></div>

            <p className='title'>{ organisationKind.label }</p>
          </a>
        </div>
      }) }
    </div>}
    { !externalType && <div>
      <div className='margin-bottom'>{ i18n.t('user.campaigns.no_organisation_notice', { client_name: user.clientName }) }</div>
      <div><a className='button primary' onClick={() => dispatch({ stage: 'startCampaign' })}>Choose for me</a></div>
     </div> }
    { externalType && <OrganisationSearcher /> }
  </div>
}

function OrganisationSearcher() {
  const { state, dispatch, actions } = useContext(Context)
  const { campaignId, externalType, organisations } = state

  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)

  const dSearch = useMemo(() => _.debounce((query) => {
    restClient.get(`/api/campaigns/${campaignId}/search_organisations`, { params: { query, externalType }})
      .then((response) => dispatch({ organisations: response.data }))
      .finally(() => setLoading(false))
  }, 500), [])

  useEffect(() => {
    if (query && query.length < 3) return
    setLoading(true)
    dSearch(query)
  }, [query])

  return <div>
      <input type='search' onChange={e => setQuery(e.target.value || '')} />
      { loading && <Loading /> }
      <table className='flat-table margin-top'>
        <tbody>
          { !loading && organisations.map((organisation) => {
            return <tr key={organisation.id} onClick={() => actions.chooseOrg(organisation.id)} className='cursor-pointer'>
              <td>
                { organisation.name }
              </td>
            </tr>
          }) }
          { !loading && organisations.length === 0 && <tr>
            <td>{ i18n.t('user.campaigns.no_organisation_found') }</td>
          </tr> }
        </tbody>
      </table>
    </div>
}
